import type { RouteRecordNormalized } from 'vue-router';
import { DEFAULT_LAYOUT } from './base';

const modules = import.meta.glob('./modules/cms*', { eager: true });
// const externalModules = import.meta.glob('./externalModules/*.ts', {
//   eager: true,
// });

function formatModules(_modules: any, result: RouteRecordNormalized[]) {
  Object.keys(_modules).forEach((key) => {
    const defaultModule = _modules[key].default;
    if (!defaultModule) return;
    const moduleList = Array.isArray(defaultModule)
      ? [...defaultModule]
      : [defaultModule];
    result.push(...moduleList);
  });
  return result;
}

function formatModulesWithDefaultLayout(routers: any) {
  return [
    {
      path: '/cms',
      name: 'cmszz',
      component: DEFAULT_LAYOUT,
      children: routers,
    },
  ];
}

export const appRoutes: RouteRecordNormalized[] = formatModules(modules, []);
export const appRoutesWithDefaultLayout = formatModulesWithDefaultLayout(
  formatModules(modules, [])
);

// export const appExternalRoutes: RouteRecordNormalized[] = formatModules(
//   externalModules,
//   []
// );
